import React from "react";

// Brand mark: sound-wave crossed with an editorial quotation mark.
// Uses currentColor for stroke — inherit via `text-*` on parent.
export function BrandMark({ size = 28, className = "" }) {
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} className={className}
         aria-hidden focusable="false">
      {/* Sound-wave bars */}
      <g strokeLinecap="round">
        <line x1="6"  y1="20" x2="6"  y2="20" stroke="currentColor" strokeWidth="3" />
        <line x1="11" y1="14" x2="11" y2="26" stroke="currentColor" strokeWidth="3" />
        <line x1="16" y1="10" x2="16" y2="30" stroke="currentColor" strokeWidth="3" />
        <line x1="21" y1="16" x2="21" y2="24" stroke="currentColor" strokeWidth="3" />
      </g>
      {/* Curly quotation mark, forming the identity twist */}
      <path d="M32 12 c 3 0 5 2 5 5 c 0 3 -2 5 -5 5 c 0 3 2 5 4 5"
            fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function BrandLockup({ compact = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="h-10 w-10 rounded-2xl bg-gradient-to-br from-cyan-400/20 to-violet-500/10 border border-cyan-400/30 flex items-center justify-center text-cyan-300">
        <BrandMark size={22} />
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className="font-heading font-bold text-sm tracking-tight">ŞARKI SÖYLEYEN</div>
          <div className="font-literary italic text-cyan-300 text-sm -mt-0.5">Deyimler</div>
        </div>
      )}
    </div>
  );
}
